import React from 'react';

import silhouettes from 'web-assets/images/lp/tumblechef-silhouettes.svg';
import appScreen from 'web-assets/images/lp/tumblechef-app-screen.png';
import logo from 'web-assets/images/lp/tumblechef-full-big.svg';
import measurements from 'web-assets/images/lp/measurements-icon.jpeg';

import {
  Icon,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

const Handspring = () => (
  <S.MainContainer>
    <S.Container>
      <Flex
        width="100%"
        justify="space-between"
      >
        <S.Header>
          <S.Title>6-Week Recipes to a HandSpring Program</S.Title>
          <S.FullLogo>
            <img
              src={logo}
              alt=""
              width="350px"
            />
          </S.FullLogo>
          <Text size="1.2em">
            Presented by TumbleChef
          </Text>
          <Text size="1em">
            All the ingredients to understand and correct weaknesses for a flawless handspring.
            Suitable for athletes and coaches.
          </Text>
          <S.FusionButton
            href="https://tumblechef.app.gymcloud.com/handspringprogram"
          >
            Sign Up
          </S.FusionButton>
        </S.Header>
        <S.DesctopLogo>
          <img
            src={logo}
            alt=""
            width="350px"
          />
        </S.DesctopLogo>
      </Flex>
    </S.Container>
    <S.Container>
      <S.AppScreen>
        <img src={appScreen} alt="" />
      </S.AppScreen>
    </S.Container>
    <S.BioSection>
      <S.BioContainer>
        <Flex>
          <img src={measurements} alt="" />
        </Flex>
        <Text size="18px">
          I&apos;m Eric Thompson, aka TumbleChef, and I&apos;ve been coaching tumbling
          for almost two decades. I am USASF certified and have worked with national
          and world champion gymnasts, cheerleaders, and power tumblers. I&apos;ve successfully
          taught thousands of handsprings using this program and am eager to share my secrets
          to success with you.
        </Text>
      </S.BioContainer>
    </S.BioSection>
    <S.DarkContainer>
      <S.Container>
        <Flex column spacing={40} className="mobile-center">
          <Text weight="bold" size="2.8em">
            Perfect Your Handspring
          </Text>
          <Text size="20px">
            All the exercises, stretches, conditioning,
            and drills you need to understand and improve your handspring in 6 weeks
            -- All at your fingertips on your phone or laptop on the TumbleChef App
            PLUS a weekly Facebook live breakdown and Q&A for individualized coaching.
          </Text>
          <Flex column spacing={10}>
            <Text size="20px">
              Overcome the 3 main obstacles to a successful handspring:
            </Text>
            <Flex
              align="center"
              spacing={5}
            >
              <Icon size="1.2em" type="fa-check-circle fas" />
              <Text size="1.2em">
                Shoulder mobility
              </Text>
            </Flex>
            <Flex
              align="center"
              spacing={5}
            >
              <Icon size="1.2em" type="fa-check-circle fas" />
              <Text size="1.2em">
                Strength
              </Text>
            </Flex>
            <Flex
              align="center"
              spacing={5}
            >
              <Icon size="1.2em" type="fa-check-circle fas" />
              <Text size="1.2em">
                Jump ability
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </S.Container>
    </S.DarkContainer>
    <S.Container>
      <img src={silhouettes} alt="" />
    </S.Container>
    <S.Container>
      <Flex column spacing={40} className="mobile-center">
        <Text size="2.8em">
          Program Details
        </Text>
        <Flex column spacing={15}>
          <S.ListItem>
            <Icon size="1.2em" type="fa-check-circle fas" />
            <Text size="1.2em">
              3 days per week for 6 weeks -- 18 workouts
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Icon size="1.2em" type="fa-check-circle fas" />
            <Text size="1.2em">
              Requires little gym equipment -- Can be modified for home use
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Icon size="1.2em" type="fa-check-circle fas" />
            <Text size="1.2em">
              Weekly discussion includes skill deconstruction, conditioning,
              spotting, stretching, skill corrections, and equipment modifications
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Icon size="1.2em" type="fa-check-circle fas" />
            <Text size="1.2em">
              Results entry and tracking
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Icon size="1.2em" type="fa-check-circle fas" />
            <Text size="1.2em">
              Price: $400
            </Text>
          </S.ListItem>
        </Flex>
        <S.FusionButton
          href="https://tumblechef.app.gymcloud.com/handspringprogram"
        >
          Sign Up
        </S.FusionButton>
      </Flex>
    </S.Container>
  </S.MainContainer>
);

export default Handspring;
